<!-- <div [ngClass]="categoryId4 === 0 ? 'border' : 'noclass'">

  <div *ngIf="categoryId5==0">
    <calsoft-common-header-carousel [other]="other" [item]="item" [header]="header"
      [id]="id"></calsoft-common-header-carousel>
  </div>
  <div *ngIf="categoryId5==1">

  </div>


  <div *ngIf="categoryId5==2||categoryId5==3">
    <div [style.background-color]="item.customField25" class="commonHeader" fxLayout="row"
      fxLayoutAlign="space-between center">
      <span style="   
      font-weight: 500;"  [ngStyle.gt-md]="{'font-size': item.customField39 }"
                        [ngStyle.lt-md]="{
                            
                            'font-size': item.customField40
                        }">{{header | uppercase}}</span>
    </div>
  </div>

  <div  *ngIf="categoryId4==0">
    <div fxLayout="row" fxLayout.xs="row wrap">
      <ng-container *ngFor="let product of categoryProducts; let i=index">
        <div class="br5"  [fxFlex.xs]="calculateMobileFlex(mobileSize2)" fxLayoutGap="10px"   [fxFlex]="calculateFlex(size)">
          <div fxLayoutAlign="center center" ngClass.gt-md="carousel-gap" style="border: 2px solid #eee;">
            <calsoft-common-product-details-carousel [data]="data" [width]="width" [imageType]="imageType"
              [height]="height" [heightMobile]="heightMobile" [widthMobile]="widthMobile"
              [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
              [showCartIncremented]="showCartIncremented" [product]="product"></calsoft-common-product-details-carousel>
  
          </div>
  
        </div>
      </ng-container>
    </div>
  
  </div>

  <div  *ngIf="categoryId4==1">
    <div fxLayout="row" fxLayout.xs="row wrap"  >
      <ng-container *ngFor="let product of categoryProducts; let i=index">
        <div class="br5"  [fxFlex.xs]="calculateMobileFlex(mobileSize2)" fxLayoutGap="10px"   [fxFlex]="calculateFlex(size)">
          <div fxLayoutAlign="center center" ngClass.gt-md="carousel-gap" >
            <calsoft-common-product-details-carousel [data]="data" [width]="width" [imageType]="imageType"
              [height]="height" [heightMobile]="heightMobile" [widthMobile]="widthMobile"
              [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
              [showCartIncremented]="showCartIncremented" [product]="product"></calsoft-common-product-details-carousel>
  
          </div>
  
        </div>
      </ng-container>
    </div>
  
  </div>

  <div  *ngIf="categoryId5==3" fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px; padding-bottom: 10px;">
    <button  class=" btn"
    (click)="goToCategory()" >{{item.customField26}}</button>
  </div>

</div> -->

<div [ngClass]="categoryId4 === 0 ? 'border' : 'noclass'">

  <div *ngIf="categoryId5==0">
    <calsoft-common-header-carousel [other]="other" [item]="item" [header]="header"
      [id]="id"></calsoft-common-header-carousel>
  </div>
  <div *ngIf="categoryId5==1">

  </div>


  <div *ngIf="categoryId5==2||categoryId5==3">
    <div [style.background-color]="item.customField25" style="padding: 10px;" fxLayout="row"
      fxLayoutAlign="space-between center" class="commonHeader" fxLayoutGap="20px">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutAlign.xs="start start"
        fxLayoutGap="20px">
        <div style="   
          font-weight:bold;" [ngStyle.gt-md]="{'font-size': item.customField39 }" [ngStyle.lt-md]="{
          'font-size': item.customField40}" [innerHTML]="header ">
        </div>

        <div *ngIf="item.customField31 && !isDealOver" fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
          <span>{{item.customField25}}</span>
          <mat-chip color="primary" selected class="countdown">
            {{ days }}d&nbsp;&nbsp;:&nbsp;&nbsp;{{ hours }}h&nbsp;&nbsp;:&nbsp;&nbsp;{{ minutes
            }}m&nbsp;&nbsp;:&nbsp;&nbsp;{{ seconds }}s
          </mat-chip>
        </div>
      </div>


      <div style="cursor: pointer;" *ngIf="item.customField26" fxFlex fxLayout="row" fxLayoutAlign="end end"
        fxLayoutGap="7px">
        <h3 (click)="goToCategory()">{{item.customField26}}</h3>
        <mat-icon style="font-size: 22px;">arrow_forward</mat-icon>
      </div>
    </div>

  </div>

  <div *ngIf="categoryId5==4">
    <div [style.background-color]="item.customField25" style="padding: 10px;" fxLayout="row"
      fxLayoutAlign="space-between center" fxLayoutGap="20px">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutAlign.xs="start start"
        fxLayoutGap="20px">
        <div style="   
          font-weight:bold;" [ngStyle.gt-md]="{'font-size': item.customField39 }" [ngStyle.lt-md]="{
          'font-size': item.customField40}" [innerHTML]="header | uppercase">
        </div>

        <div *ngIf="item.customField31 && !isDealOver" fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
          <span>Deals ends in</span>
          <mat-chip color="primary" selected class="countdown">
            {{ days }}d&nbsp;&nbsp;:&nbsp;&nbsp;{{ hours }}h&nbsp;&nbsp;:&nbsp;&nbsp;{{ minutes
            }}m&nbsp;&nbsp;:&nbsp;&nbsp;{{ seconds }}s
          </mat-chip>
        </div>
      </div>


      <div *ngIf="item.customField26" fxFlex fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="7px">
        <h3 (click)="goToCategory()">{{item.customField26}}</h3>
        <mat-icon style="font-size: 22px;">arrow_forward</mat-icon>
      </div>
    </div>

  </div>

  <div *ngIf="categoryId4==0">
    <div fxLayout="row wrap">
      <ng-container *ngFor="let product of categoryProducts; let i=index">
        <div class="br5" [fxFlex.xs]="calculateMobileFlex(mobileSize2)" fxLayoutGap="10px"
          [fxFlex]="calculateFlex(size)">
          <div fxLayoutAlign="center center" ngClass.gt-md="carousel-gap" style="border: 2px solid #eee;">
            <calsoft-common-product-details-carousel [data]="data" [width]="width" [imageType]="imageType"
              [height]="height" [heightMobile]="heightMobile" [widthMobile]="widthMobile" [productLayoutEnable]="productLayoutEnable"
              [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
              [showCartIncremented]="showCartIncremented" [product]="product"></calsoft-common-product-details-carousel>

          </div>

        </div>
      </ng-container>
    </div>

  </div>

  <div *ngIf="categoryId4==1" >
    <div fxLayout="row wrap" >
      <ng-container *ngFor="let product of categoryProducts; let i=index">
        <div class="br5" [fxFlex.xs]="calculateMobileFlex(mobileSize2)" 
          [fxFlex]="calculateFlex(size)" [ngStyle]="getPaddingStyle(i)">
          <div fxLayoutAlign="center center" ngClass.gt-md="carousel-gap">
            <calsoft-common-product-details-carousel [data]="data" [width]="width" [imageType]="imageType"
              [height]="height" [heightMobile]="heightMobile" [widthMobile]="widthMobile"
              [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
              [showCartIncremented]="showCartIncremented" [product]="product"></calsoft-common-product-details-carousel>

          </div>

        </div>
      </ng-container>
    </div>

  </div>

  <div *ngIf="categoryId5==3" fxLayout="row" fxLayoutAlign="center center"
    style="padding-top: 10px; padding-bottom: 10px;">
    <button class=" btn" (click)="goToCategory()">{{item.customField26}}</button>
  </div>

</div>